import { createAction } from '@reduxjs/toolkit';

import { SUBMIT_LOGIN_FORM } from './actionTypes';

export const submitLoginForm = createAction(SUBMIT_LOGIN_FORM);
